<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_12"></a><a id="part002"></a><strong>Organizing There Is a Simpler Way</strong></h2>
<p class="right"><a id="page_13"></a>The New Story Is Ours to Tell<br/>The Irresistible Future of Organizing<br/>The Promise and Paradox of Community<br/>Relying on Human Goodness<br/>The Best in Art and Life</p>
<p class="noindent">Each of these essays describes the new story, describing different capabilities and dynamics of all living systems, including people. This is the foundation, the theory base, for all that follows in later essays when I apply these dynamics to leadership and organizational practices.</p>
<p class="noindent"><a id="page_14"></a>The whole globe is shook up, so what are you going to do when things are falling apart? You’re either going to become more fundamentalist and try to hold things together, or you’re going to forsake the old ambitions and goals and live life as an experiment, making it up as you go along.</p>
<p class="attribute1">—Pema Chödrön</p>
<p class="image"><a id="page_15"></a><img alt="Image" src="images/f0015-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part002.vue?cc538148